import * as React from 'react';

import styled from 'styled-components';

import { DistributionEarnings } from '@webapp/types/ui/earnings/distribution-earnings';

import EarningsListCtrl from './earnings-list';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
// import { Translate } from 'react-localize-redux';

interface EarningsItemSummaryCtrlProps {
  className?: string;
  title?: React.ReactNode;
  titleTotal?: React.ReactNode;
  total?: string;
  items: DistributionEarnings[];

  isTotal?: boolean;
  isPro?: boolean;
  totalWeekly?: string;
}

export const EarningsItemSummaryCtrl: React.FC<EarningsItemSummaryCtrlProps> = (
  props
) => {
  return (
    <div className={props.className}>
      {props.title && (
        <HeaderTitle
          weight={props.titleTotal ? '400' : '700'}
          type="subheader-small"
        >
          {props.title}
        </HeaderTitle>
      )}
      <div>
        {props.items.map((item) => (
          <EarningsListCtrl
            key={`${props.title}-${item.category}`}
            title={item.category}
            revenue={item.revenue}
          />
        ))}
      </div>
      {props.total && (
        <Footer>
          <FooterWrapper justifyContent="space-between" alignItems="center">
            <Typography weight="700" type="subheader-small">
              {props.titleTotal}
            </Typography>
            <Typography weight="700" type="subheader-small" align="right">
              {props.total}
            </Typography>
          </FooterWrapper>
          {/* {props.isPro && (
            <FooterWrapper
              className="mt-10"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography opacity=".5">
                <Translate id="USER_PROFILE.WALLET.EARNINGS.WEEK" />
              </Typography>
              <Typography type="title" weight="400">
                {props.totalWeekly}
              </Typography>
            </FooterWrapper>
          )} */}
        </Footer>
      )}
    </div>
  );
};

export default styled(EarningsItemSummaryCtrl)`
  margin-top: 40px;

  &:first-child {
    margin-top: 0;
  }
`;

const HeaderTitle = styled(Typography)`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  & > svg {
    max-width: 100px;
    height: 32px;
  }
`;

const Footer = styled.div`
  margin-top: 15px;
`;

const FooterWrapper = styled(Flex)`
  width: 100%;
`;
